import { useContext } from "react";
import { useSubscriptionRequestByUserId, useSubscriptionRequestByVibeId } from "../user/api/queries";
import { UserContext } from "../App";
export const useSubscriptionItems = () => {
    const user = useContext(UserContext);
    const vibeIdResult = useSubscriptionRequestByVibeId(user?.vibeId || "");
    const userIdResult = useSubscriptionRequestByUserId(user?.id || "");
    const result = user?.vibeId &&
        vibeIdResult?.data?.subscriptionRequestsByVibeId &&
        !vibeIdResult.error
        ? vibeIdResult
        : userIdResult;
    const { data, loading, refetch } = result;
    const subscriptionCollection = data?.subscriptionRequestsByVibeId?.nodes || data?.subscriptionRequestsByUserId?.nodes || [];
    return [subscriptionCollection, loading, refetch];
};
